import React, { useState, useEffect, Fragment } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { Row, Col, Table, Spinner } from "react-bootstrap";
import Edit from "./Edit";
import ErrorModal from "../../ErrorModal";
import DeleteConfirmation from "../../shared/DeleteConfirmation";
import MyJustDate from "../../shared/MyJustDate";

const baseURL = process.env.REACT_APP_API_JOBS;

const Listdelete = ({
  increment,
  counter,
  setCounter,
  moamad_id,
  moamad,
  hagsha_aharon,
}) => {
  const [courses, setCourses] = useState(null);
  const [crsId, setCrsId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const hagshaDate = MyJustDate(new Date(Date.parse(hagsha_aharon)));
  const currentDate = MyJustDate(Date.now());

  const readOnly =
    moamad.signature_date ||
    (hagshaDate && currentDate && hagshaDate < currentDate);

  /*const readOnly =
    moamad.signature_date ||
    MyJustDate(new Date(Date.parse(hagsha_aharon))) < MyJustDate(Date.now());*/
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "course?moamad_id=" + moamad_id,
          {
            signal: controller.signal,
          }
        );
        isMounted && setCourses(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [counter]);
  const handleEditClick = (event, crs) => {
    event.preventDefault();
    setCrsId(crs.id);
  };
  const handleCancelClick = () => {
    setCrsId(null);
  };

  if (!courses) return null;
  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div>
          <Row>
            <Col sm="10" md={{ size: 3, offset: 1 }}>
              <form onSubmit={increment}>
                <Table hover>
                  <thead>
                    <tr>
                      <th>שם הקורס/השתלמות</th>
                      <th>משך הקורס</th>
                      <th>תקופה מ-</th>
                      <th>תקופה עד-</th>
                      <th>מסגרת לימודים</th>
                      <th>תעודת גמר</th>
                    </tr>
                  </thead>
                  <tbody>
                    {courses?.map((crs) => (
                      <Fragment key={crs.id}>
                        {crsId === crs.id ? (
                          <Edit
                            crs={crs}
                            handleCancelClick={handleCancelClick}
                            increment={increment}
                            counter={counter}
                            setCrsId={setCrsId}
                          />
                        ) : (
                          <ReadOnlyRows
                            crs={crs}
                            handleEditClick={handleEditClick}
                            increment={increment}
                            setCrsId={setCrsId}
                            setShowError={setShowError}
                            setErrorMessage={setErrorMessage}
                            setErrorHeader={setErrorHeader}
                            readOnly={readOnly}
                          />
                        )}
                      </Fragment>
                    ))}
                  </tbody>
                </Table>
              </form>
            </Col>
          </Row>
        </div>
        <ErrorModal
          showError={showError}
          setShowError={setShowError}
          errorMessage={errorMessage}
          errorHeader={errorHeader}
        />
      </>
    );
  }
};
export default Listdelete;

const ReadOnlyRows = ({
  crs,
  handleEditClick,
  setCrsId,
  increment,
  setShowError,
  setErrorMessage,
  setErrorHeader,
  readOnly,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(`מחיקת השכלה "${crs.title}": האם אתה בטוח? `);
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const delData = async () => {
      try {
        const response = await axiosPrivate.delete(
          baseURL + "course/" + crs.id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setCrsId(null);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    delData();
  };

  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={crs.id}
        event={deleteObj}
        message={deleteMessage}
      />
      <tr>
        <td>{crs.title}</td>
        <td>{crs.length}</td>
        <td>{crs.start_date}</td>
        <td>{crs.end_date}</td>
        <td>{crs.education_frame}</td>
        <td>{crs.certifcate}</td>
        <td>{crs.end_year}</td>
        <td style={{ textAlign: "left", direction: "rtl" }}>
          <div className="d-flex justify-content-end">
            <button
              disabled={readOnly}
              type="button"
              className="btn btn-success"
              onClick={(event) => handleEditClick(event, crs)}
            >
              <FiEdit2 />
            </button>
            <span> </span>

            <button
              disabled={readOnly}
              type="button"
              className="btn btn-danger space-button"
              onClick={(event) => showDeleteModal("courses", crs.id, event)}
            >
              <FiTrash2 />
            </button>
          </div>
        </td>
      </tr>
    </>
  );
};
